module.exports = __webpack_public_path__ + "img/banner.807d555d.jpg";